import React from 'react';
import './subscription.scss';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import PageHeader from '../../../components/base/PageHeader/PageHeader';
import {
  Button, Col, Container, Row,
} from '../../../components/base/BootstrapComponents';
import { getSubscriptionData } from '../reducer';
import notificationDecorator from '../../Notifications/notificationDecorator';
import { responseLogWithNotification } from '../../../utils/utils';
import { createSubscriptionType, editSubscriptionType } from '../actions';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import SubscriptionPresetDTO from '../../../dto/SubscriptionPresetDTO';

export default function SubscriptionPresetForm(props) {
  const {
    handleClose = () => {}, handleEdit = () => {}, loadData = () => {}, hasView = false,
  } = props;
  const dispatch = useDispatch();
  const { currentSubscriptionType } = useSelector(getSubscriptionData);
  const { control, getValues } = useForm({
    defaultValues: currentSubscriptionType?.id ? currentSubscriptionType : {},
  });

  const handleSave = () => {
    const isUpdate = currentSubscriptionType?.id;
    const action = isUpdate ? editSubscriptionType : createSubscriptionType;
    const data = getValues();
    dispatch(action(data))
      .then(() => {
        loadData();
        handleClose();
        notificationDecorator({
          title: isUpdate ? 'Редактирование пресета' : 'Создание пресета',
          message: isUpdate ? 'Редактирование пресета прошло успешно' : 'Создание пресета прошло успешно',
        });
      })
      .catch(responseLogWithNotification);
  };

  const subscriptionPresetDto = new SubscriptionPresetDTO();
  const attributes = subscriptionPresetDto.getAttributesByName();

  return (
    <div className="page-container subs-form">
      <div className="inputs-box">
        <PageHeader header={currentSubscriptionType ? 'Редактирование пресета' : 'Создание пресета'} />
      </div>
      <div className="plp-table g-0">
        <div className="frame py-3 d-flex">
          <Container className="subs-form-container">
            <Row className="h-100">
              <Col columns={6}>
                <div className="d-flex flex-row justify-content-between align-items-center">
                  <div className="h4">
                    Данные пресета
                  </div>
                </div>
                <FieldDTO
                  control={control}
                  type="text"
                  className="mb-2"
                  dtoObject={attributes.name}
                  addPlaceholder
                  component={TextInputWithLabel}
                  disabled={hasView}
                />
                <FieldDTO
                  control={control}
                  type="number"
                  className="mb-2"
                  dtoObject={attributes.duration}
                  addPlaceholder
                  component={TextInputWithLabel}
                  disabled={hasView}
                />
                <FieldDTO
                  control={control}
                  type="number"
                  className="mb-2"
                  dtoObject={attributes.price}
                  addPlaceholder
                  component={TextInputWithLabel}
                  disabled={hasView}
                />
                <FieldDTO
                  control={control}
                  type="number"
                  className="mb-2"
                  dtoObject={attributes.priority}
                  addPlaceholder
                  component={TextInputWithLabel}
                  disabled={hasView}
                />
                <div className="text-center justify-content-center p-3">
                  {!hasView
                    ? <Button className="me-3 px-3" onClick={handleSave}>Сохранить</Button>
                    : <Button className="me-3 px-3" onClick={handleEdit(currentSubscriptionType)}>Редактировать</Button>}

                  <Button variant="secondary" className="px-3" onClick={handleClose}>Закрыть</Button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </div>
  );
}
